import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, Divider, List, ListItem, ListItemIcon, ListItemText, Box, Button } from '@material-ui/core'
import ChevronRightSharpIcon from '@material-ui/icons/ChevronRightSharp';

const useStyles = makeStyles(theme => ({
    cover: {
        width: '100%',
        marginTop: '2rem'
    },
    textItem: {
        marginTop: theme.spacing(3)
    }
}))

export default function About () {

    const classes = useStyles()

    return (
        <Grid container spacing={3}>
            <Grid item sm={12}>
                <img className={classes.cover} src="/images/cover2.png" alt="Workshop Coaches Profesionales"/>
                <Box style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: '2rem' }}>
                    <Button component="a" href="#inscribete" variant="outlined" color="primary">
                        Inscribirse
                    </Button>
                </Box>
            </Grid>
            <Grid item sm={12}>
                <Typography style={{ padding: '1rem', marginTop: '2rem', backgroundColor: '#283593', color: '#fff', textAlign: 'center' }} className={classes.textItem} component="h3" variant="h5" gutterBottom>
                    ¿A quién va dirigido?
                </Typography>
                <Typography className={classes.textItem} component="p" variant="subtitle1" gutterBottom>
                Exclusivamente a <b>coaches profesionales</b>. Si eres coach y te dedicas profesionalmente a esta profesión, este taller podrá cambiar tu desempeño profesional.
                </Typography>
                {/* <Typography className={classes.textItem} component="p" variant="subtitle1" gutterBottom>
                    Impartido por la Coach y Conferencista internacional: MCC Elena Espinal
                </Typography>
                <Typography className={classes.textItem} component="p" variant="subtitle1" gutterBottom>
                    Cupo limitado
                </Typography> */}
                <Typography style={{ padding: '1rem', marginTop: '2rem', backgroundColor: '#283593', color: '#fff', textAlign: 'center' }} className={classes.textItem} component="h3" variant="h5" gutterBottom>
                    ¿Qué te vas a llevar de este taller?
                </Typography>
                <List dense={false}>
                    <ListItem>
                        <ListItemIcon>
                            <ChevronRightSharpIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary="El poder de los Estados de ánimo en la visión de futuro."
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <ChevronRightSharpIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary="La generación de espacios reveladores en tus conversaciones."
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <ChevronRightSharpIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary="Un mundo más grande para generar posibilidades infinitas a tus clientes."
                        />
                    </ListItem>
                </List>
                {/* <Typography style={{ padding: '1rem', marginTop: '2rem', backgroundColor: '#283593', color: '#fff', textAlign: 'center' }} className={classes.textItem} component="h3" variant="h5" gutterBottom>
                    Programa
                </Typography>

                <Box style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: '2rem' }}>
                    <Button component="a" href="#inscribete" variant="outlined" color="primary">
                        Inscribirse
                    </Button>
                </Box> */}

                <Typography style={{ padding: '1rem', marginTop: '2rem', backgroundColor: '#283593', color: '#fff', textAlign: 'center' }} className={classes.textItem} component="h3" variant="h5" gutterBottom>
                    Día del Taller y Modalidad
                </Typography>
                <Typography className={classes.textItem} style={{ color: '#b71c1c' }} align="center" variant="h5" gutterBottom>
                    Sábado, 19 de octubre de 2019 <br/>
                    De 9:00 a 13:00 (hora de Madrid)
                </Typography>
                <Grid container spacing={3}>
                    <Grid item sm={12} md={6}>
                        <Typography className={classes.textItem} variant="h6" gutterBottom>
                            PRESENCIAL EN MADRID:<br/>
                            Inspira WorkSpace
                        </Typography>
                        <Button style={{ marginTop: '1.5rem' }} component="a" href='https://www.google.com/maps/place/ATOCHA+CENTRO+DE+NEGOCIOS/@40.404548,-3.693823,14z/data=!4m5!3m4!1s0x0:0x62a087235c7256ac!8m2!3d40.4045482!4d-3.6938232?hl=es-419' target="_blank" rel="noopener noreferrer" fullWidth color="primary">Ver en mapa</Button>
                        <Typography className={classes.textItem} component="p" variant="subtitle1" gutterBottom>
                            Paseo de las Delicias 30,<br/>
                            2a y 7a planta<br/>
                            28045, Madrid, España
                        </Typography>
                        <Typography className={classes.textItem} style={{ textAlign: 'center' }} component="p" variant="subtitle1" gutterBottom>
                            Plazas Limitadas
                        </Typography>
                    </Grid>
                    <Grid item sm={12} md={6} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography className={classes.textItem} variant="h6" gutterBottom>
                            ONLINE (POR STREAMING):
                        </Typography>
                        <Typography className={classes.textItem} component="p" variant="subtitle1" gutterBottom>
                            Online a travez de zoom
                        </Typography>
                        <Box style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 'auto' }}>
                            <Button component="a" href="#inscribete" variant="outlined" color="primary">
                                Inscribirse
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

                <Typography style={{ padding: '1rem', marginTop: '2rem', backgroundColor: '#283593', color: '#fff', textAlign: 'center' }} className={classes.textItem} component="h3" variant="h5" gutterBottom>
                    Ponente
                </Typography>
                <Grid container spacing={3}>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} sm={12} md={3}>
                        <picture style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '10rem', height: '10rem', borderRadius: '50%', overflow: 'hidden' }}>
                            <img style={{ height: '100%', width: 'auto' }} src="/images/photo.jpg" alt="Elena Espinal"/>
                        </picture>
                    </Grid>
                    <Grid item sm={12} md={9}>
                        <Typography className={classes.textItem} component="p" variant="h6" gutterBottom>
                            Elena Espinal
                        </Typography>
                        <Typography className={classes.textItem} component="p" variant="subtitle1" gutterBottom>
                            Master Coach y conferencista internacional. Fundadora del Instituto de Coaching Profesional (ICP) en Argentina, donde se dicta la primer carrera de Coaching en el mundo con reconocimiento oficial. Creadora y Directora de la Maestría en Coaching Organizacional de Universidad Londres de México. Socia fundadora de Team Power.
                        </Typography>
                    </Grid>
                </Grid>

                <Typography style={{ padding: '1rem', marginTop: '2rem', backgroundColor: '#283593', color: '#fff', textAlign: 'center' }} className={classes.textItem} component="h3" variant="h5" gutterBottom>
                    Precio de Inscripción
                </Typography>

                <Grid container spacing={5}>
                    <Grid item sm={12} md={6}>
                        <Typography className={classes.textItem} component="p" variant="subtitle1" align="center" gutterBottom>
                            MODALIDAD PRESENCIAL
                        </Typography>
                        <ListItem>
                            <ListItemIcon>
                                <ChevronRightSharpIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="150 € Incluye acceso a evento y coffee break"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <ChevronRightSharpIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Precio especial comunidad ICF España: 80 €"
                            />
                        </ListItem>
                        <Typography align="justify" className={classes.textItem} component="p" variant="subtitle1" gutterBottom>
                            Si quieres pagar directo en el evento ¡también puedes hacerlo!, contáctanos para reservar tu lugar. Escríbenos a <a href="mailto:contacto@team-power.com.mx">contacto@team-power.com.mx</a>
                        </Typography>
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <Typography className={classes.textItem} align="center" component="p" variant="subtitle1" gutterBottom>
                            MODALIDAD ONLINE
                        </Typography>
                        <ListItem>
                            <ListItemIcon>
                                <ChevronRightSharpIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Transmisión online (streaming): 30€"
                            />
                        </ListItem>
                        <Typography align="justify" className={classes.textItem} component="p" variant="subtitle1" gutterBottom>
                            Si no puedes asistir de manera presencial, nosotros te llevamos el evento hasta donde está, transmisión en vivo
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}